import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../context/metaModelContext'
import type { TemplateVersionInfo } from '../../types/templateModel'
import { getTemplateHierarchy } from '../transformers/toVisualModelConverter'

/**
 * Utility hook used for retrieving the templates hierarchy given a template identifier.
 */
export const useTemplateHierarchy = ({
  forTemplate,
  withReplacements,
}: {
  forTemplate: Optional<TemplateVersionInfo>
  withReplacements: boolean
}) => {
  const { layerTopology } = useMetaModelContext()

  return useMemo(
    () =>
      forTemplate
        ? getTemplateHierarchy({
            templateInfo: forTemplate,
            shouldProcessReplacements: withReplacements,
            layerTopology,
          })
        : [],
    [forTemplate, withReplacements, layerTopology],
  )
}
